import {useState} from 'react';
import {Icon} from '@/components/atoms';
import {COLOR_CODE} from '@/utils/constants/colors';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {Button} from '@pepsico-ds/ui';
import PropTypes from 'prop-types';
import './ActionMenu.scss';

const ActionMenu = ({actionItems, onActionClick, selectedCount = 0}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Button
        onClick={handleMenuClick}
        variant='outlined'
        size='small'
        iconTrailing={
          <Icon icon='expand_more' size='small' color={COLOR_CODE._3387DF} />
        }
        className='datatable-toolbar__action-menu-btn'>
        Actions
      </Button>
      {actionItems?.length > 0 && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          slotProps={{paper: {className: 'datatable-toolbar__menu-paper'}}}>
          {actionItems?.map((action, index) => {
            return (
              <MenuItem
                key={action.id || `action-${index}`}
                onClick={() => {
                  onActionClick(action);
                  handleMenuClose();
                }}
                disabled={
                  action.disabled ||
                  (action.displayText == 'Download' && selectedCount === 0)
                }
                className='datatable-toolbar__menu-item'>
                {action.icon && (
                  <Icon
                    icon={action.icon}
                    size='primary'
                    color={COLOR_CODE._FFFFFF}
                  />
                )}
                {action.displayText || action.label}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </div>
  );
};

ActionMenu.propTypes = {
  actionItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      displayText: PropTypes.string,
      label: PropTypes.string,
      icon: PropTypes.string,
      disabled: PropTypes.bool
    })
  ),
  selectedCount: PropTypes.number,
  onActionClick: PropTypes.func.isRequired
};

export default ActionMenu;
